import { GuaranteedOfferType } from '@appTypes/App.interface'

import { ContentProps } from '@components/CreditCardContent/components/Content.interface'
import guaranteedAprContent from '@components/CreditCardContent/components/guaranteedAprContent'
import minimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/minimumGuaranteedCreditLimitContent'
import noMinimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/noMinimumGuaranteedCreditLimitContent'
import representativeAprContent from '@components/CreditCardContent/components/representativeAprContent'
import isZableProduct from '@components/CreditCardContent/utils/isZableProduct'

import getGuaranteedOfferType from '@utils/getGuaranteedOfferType'

const getPoorCreditContent = ({ creditCard }: ContentProps) => {
    const guaranteedOfferType = getGuaranteedOfferType({
        creditCard: creditCard,
    })

    const isTotallySureOffer =
        guaranteedOfferType === GuaranteedOfferType.MarketingOffer

    const shouldHideCreditLimit =
        !isTotallySureOffer && isZableProduct(creditCard.productCode)

    return [
        guaranteedAprContent({ creditCard }),
        representativeAprContent({ creditCard }),
        minimumGuaranteedCreditLimitContent({ creditCard }),
        !shouldHideCreditLimit
            ? noMinimumGuaranteedCreditLimitContent({
                  creditCard,
              })
            : null,
    ]
}

export default getPoorCreditContent
